import {useEffect, useRef, useState} from 'react'

interface FadeInProps {
  children: React.ReactNode
  className?: string
  delay?: number
}

function FadeIn({children, className = '', delay = 0}: FadeInProps) {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisible(true)
            observer.unobserve(entry.target)
          }
        })
      },
      {threshold: 0.15}
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'} ${className}`}
      style={{transitionDelay: `${delay}ms`}}
    >
      {children}
    </div>
  )
}

export default FadeIn
